(() => {
  'use strict';

  if (window.__smoofCartPreviewImagesV4) return;
  window.__smoofCartPreviewImagesV4 = true;

  const imageSelector = '[data-smoof-cart-preview-image]:not([data-smoof-cart-preview-ready])';
  const singleLinkSelector = 'a.smoof-cart-previews[href*="/uploads/"]';
  const doubleLinkSelector = '.smoof-cart-previews--double a[href*="/uploads/"]';
  let pending = false;

  function previewImage(alt) {
    const image = document.createElement('img');
    image.setAttribute('data-smoof-cart-preview-image', '');
    image.alt = alt;
    image.width = 600;
    image.height = 600;
    image.loading = 'eager';
    return image;
  }

  function isMissingImage(link) {
    return !link.querySelector('[data-smoof-cart-preview-image]');
  }

  function restoreMissingImages() {
    document.querySelectorAll(singleLinkSelector).forEach(link => {
      if (!isMissingImage(link)) return;
      link.replaceChildren(previewImage('Druckflächenvorschau'));
    });

    document.querySelectorAll(doubleLinkSelector).forEach(link => {
      if (!isMissingImage(link)) return;
      const isBack = /Rückseite|Hinten/i.test(
        `${link.getAttribute('aria-label') || ''} ${link.textContent || ''}`
      );
      link.prepend(previewImage(isBack ? 'Rückseite' : 'Vorderseite'));
    });
  }

  function hydrate() {
    pending = false;
    restoreMissingImages();

    document.querySelectorAll(imageSelector).forEach(image => {
      const link = image.closest('a[href]');
      const url = link?.href || '';
      if (!url) return;

      image.dataset.smoofCartPreviewReady = 'true';
      image.addEventListener('load', () => {
        image.dataset.smoofCartPreviewState = 'loaded';
      }, { once: true });
      image.addEventListener('error', () => {
        image.dataset.smoofCartPreviewState = 'error';
      }, { once: true });
      image.src = url;
    });
  }

  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(hydrate);
  }

  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
  document.addEventListener('cart:refresh', schedule);
  document.addEventListener('DOMContentLoaded', schedule, { once: true });
  schedule();
})();
